import DateTimeValueObject from '@/domain/shared/dateTimeValueObject/DateTimeValueObject';

export default class DataBreachOccurredOn extends DateTimeValueObject {}
